export class CreateNewUser {
    private username: string = '';
    private personName: string = '';
    private email: string = '';
    private contactno: string = '';
    private userCategory: string = '';
    private userPassword: string = '';
    private userExpiryDate: string = '';
    private isActive: boolean = true;

    constructor() { }

    // Getters & Setters

    getUsername(): string {
        return this.username;
    }
    setUsername(value: string) {
        this.username = value;
    }

    getPersonName(): string {
        return this.personName;
    }
    setPersonName(value: string) {
        this.personName = value;
    }

    getEmail(): string {
        return this.email;
    }
    setEmail(value: string) {
        this.email = value;
    }

    getContactno(): string {
        return this.contactno;
    }
    setContactno(value: string) {
        this.contactno = value;
    }

    getUserCategory(): string {
        return this.userCategory;
    }
    setUserCategory(value: string) {
        this.userCategory = value;
    }

    getUserPassword(): string {
        return this.userPassword;
    }
    setUserPassword(value: string) {
        this.userPassword = value;
    }

    getUserExpiryDate(): string {
        return this.userExpiryDate;
    }
    setUserExpiryDate(value: string) {
        this.userExpiryDate = value;
    }

    getIsActive(): boolean {
        return this.isActive;
    }
    setIsActive(value: boolean) {
        this.isActive = value;
    }

    toString() {
        return JSON.stringify({
            username: this.getUsername(),
            personName: this.getPersonName(),
            email: this.getEmail(),
            contactno: this.getContactno(),
            userCategory: this.getUserCategory(),
            userPassword: this.getUserPassword(),
            userExpiryDate: this.getUserExpiryDate(),
            isActive: this.getIsActive(),
        });;
    }
}
